const app = {
	state: {
		breadcrumb: {}, //面包屑导航
		searchBoxWidth:"260px",//搜索框宽度
		desensitizationName: localStorage.getItem('SET_desensitizationName') === 'true',//姓名脱敏
		desensitizationPhone: localStorage.getItem('SET_desensitizationPhone') === 'true',//手机号脱敏
		imageCompressWidth: localStorage.getItem('SET_imageCompressWidth') || 100,//图片压缩宽度
		noticeTotalCount: Number(localStorage.getItem('noticeTotalCount') || 0) , //告警消息总数
    messageVisible: localStorage.getItem('messageVisible') === 'true', //消息通知开关
	},
	mutations: {
		SET_BREADCRUMB: (state, breadcrumb) => {
			state.breadcrumb = breadcrumb
		},
		SET_desensitizationName: (state, onoff) => {
			state.desensitizationName = onoff
		},
		SET_desensitizationPhone: (state, onoff) => {
			state.desensitizationPhone = onoff
		},
		SET_imageCompressWidth: (state, width) => {
			state.imageCompressWidth = width
		},
		SET_noticeTotalCount: (state, count) => {
			state.noticeTotalCount = count
		},
    SET_messageVisible: (state, messageVisible) => {
			state.messageVisible = messageVisible
		},
	},
	actions: {
		SET_BREADCRUMB({ commit }) {
			return new Promise((resolve) => {
				commit('SET_BREADCRUMB')
				resolve()
			})
		},
		//设置姓名脱敏
		SET_desensitizationName({ commit }, onoff) {
			localStorage.setItem('SET_desensitizationName', onoff)
			commit('SET_desensitizationName', onoff)
		},
		//设置手机号脱敏
		SET_desensitizationPhone({ commit }, onoff) {
			localStorage.setItem('SET_desensitizationPhone', onoff)
			commit('SET_desensitizationPhone', onoff)
		},
		//设置图片压缩宽度
		SET_imageCompressWidth({ commit }, width) {
			localStorage.setItem('SET_imageCompressWidth', width)
			commit('SET_imageCompressWidth', width)
		},
		//设置告警消息的总条数
		SET_noticeTotalCount({ commit }, count) {
			localStorage.setItem('noticeTotalCount', count)
			commit('SET_noticeTotalCount', count)
		},
		SET_messageVisible({ commit }, messageVisible) {
				localStorage.setItem('messageVisible', messageVisible)
				commit('SET_messageVisible', messageVisible)
			},
	}
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js